import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var BadGatewayError = function BadGatewayError() {
    _classCallCheck(this, BadGatewayError);
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/bad-gateway.js
// module id = ./src/abstractions/errors/bad-gateway.js
// module chunks = 34